import { Box, Grid, Select,FormControl,InputLabel } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserCountries,
  GetCustomerGroupReferenceData,
  SearchCustomerTrustLevel,
  UpdateCustomerTrustLevel,
  setState,
} from "./functionalAdminSlice";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import _ from "lodash";
import CustomButton from "../../components/ui/CustomButton";
import CustomLoadingScreen from "../../components/ui/CustomLoadingScreen";
import MessageSnackbar from "../../components/ui/MessageSnackbar";


const CustomerTrustLevel = () => {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  const [partnerType, setPartnerType] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [searchText, setSearchText] = useState("");
  const [alert, setAlert] = useState({});
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [updatedValues, setUpdatedValues] = React.useState([]);
  //Only get Initial Values Data
  const functionAdmin = useSelector((state) => state.functionAdmin);
  const {
    isLoading,
    countries,
    selectedCountry,
    selectedCountryID,

    getCustomerGroupRefData,
    customerTrustLevelData,
  } = functionAdmin;

  const [rows, setRows] = useState([]);
  const [showCustomerTrustLevel,setShowCustomerTrustLevel]=useState(false);

  const columns = [
    { 
      field: "custID", headerName: "Customer Number", flex: 1 ,  
      renderCell: (params) => (
      <div title={params.row.pName} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {params.value}
      </div>
    )
  },
  {
    field: "customerName",
    headerName: "Customer Name",
    flex: 1,
    renderCell: (params) => (
      <div title={params.row.pName} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {params.value}
      </div>
    )
  },
    {
      field: "cgName",
      headerName: "Customer Group",
      flex: 1,
    },
    {
      field: "trustLevel",
      headerName: "Relationship Level",
      flex: 1,
      renderCell: (params) => {
        return <TrustLevel {...params} />;
      },
    },
  ];

  useEffect(() => {
    dispatch(setState("selectedCountry", ""));
    setPartnerType("");
    setCustomerType("");
    setShowCustomerTrustLevel(false);
  }, []);

  const TrustLevel = (params) => {
    const [trustLevel, setTrustLevel] = useState(params.row.trustLevel);

    const handleStatusChange = (e) => {
      setTrustLevel(e.target.value);
      apiRef.current.updateRows([
        { id: params.id, trustLevel: e.target.value },
      ]);
      setUpdatedValues((prev) => [...prev, params.row]);
    };
    return (
      <Select
        value={trustLevel}
        onChange={handleStatusChange}
        variant="outlined"
        size="small"
        fullWidth
      >
        <MenuItem value={1}>High</MenuItem>
        <MenuItem value={2}>Medium</MenuItem>
        <MenuItem value={3}>Low</MenuItem>
        <MenuItem value={4}>Others</MenuItem>
      </Select>
    );
  };


  useEffect(() => {
    if (customerTrustLevelData.length > 0) {
      setRows(customerTrustLevelData);
    }
    else{
      setRows([]);
    }
  }, [customerTrustLevelData]);
  useEffect(() => {
    //Send data through the function in Slice
    dispatch(GetCustomerGroupReferenceData({ CountryID: selectedCountryID }));
  }, [selectedCountryID]);


  useEffect(() => {
    if (countries.length <= 0) {
      //Send data through the function in Slice
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, [searchText]);

  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
  };

  const displayAlert = (severityType) => {
    setAlert({
      alertSeverity: "info",
      alertDisplay: true,
      alertMessage: `Please select the ${severityType}`,
    });

    setTimeout(() => {
      clearAlert();
    }, [3000]);
  };

  const displaySuccess = () => {
    setAlert({
      alertSeverity: "success",
      alertDisplay: true,
      alertMessage: `Saved Successfully!`,
    });

    setTimeout(() => {
      clearAlert();
    }, [3000]);
  };

  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };

  const handleDisplay = () => {
    if (selectedCountry === null || selectedCountry === "") {
      displayAlert("Country");
      return;
    }
    if (partnerType === null || partnerType === "") {
      displayAlert("Partner Type");
      return;
    }
    if (customerType === null || customerType === "") {
      displayAlert("Customer Type");
      return;
    }
    let obj = {
      CountryID: selectedCountryID,
      CustomerName: searchText,
      CustomerCodeType: customerType,
      PartnerType: partnerType,
    };

    setShowCustomerTrustLevel(true);
    dispatch(SearchCustomerTrustLevel(obj));
  };

  const handleCountryChange = (e) => {
    setShowCustomerTrustLevel(false);
    setPartnerType("");
    setCustomerType("");
    const name = e.target.value;
    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  const handleSave =async() => {
    try{
      const finalArray = rowSelectionModel.map((id) => {
        let updatedTrustValues = apiRef.current.getRowWithUpdatedValues(id);
        return {
          id: updatedTrustValues.id,
          trustLevel: updatedTrustValues.trustLevel,
          stickToQuota: updatedTrustValues.stickToQuota,
        };
      });
  
      let obj = {
        CountryID: selectedCountryID,
        CustomerName: searchText,
        CustomerCodeType: customerType,
        PartnerType: partnerType,
      };
  
      await dispatch(UpdateCustomerTrustLevel(finalArray));
      await dispatch(SearchCustomerTrustLevel(obj));

      displaySuccess();
      setRowSelectionModel([]);
    }
    catch(error){
      console.error("Error in handle save",error);
    }
    
  };

  const handlePartnerTypeChange=(e)=>{
    setShowCustomerTrustLevel(false);
    setPartnerType(e.target.value);
  }
  const handleCustomerTypeChange=(e)=>{
    setShowCustomerTrustLevel(false);
    setCustomerType(e.target.value);
  }

  const handleCloseSnackbar=()=>{
    clearAlert();
  }

  return (
    <Box mt={2}>
        <Box>
        <CustomLoadingScreen isLoading={isLoading} />
        </Box>
        <Box mt={2}>
          <Grid
            container
            spacing={2}
            alignItems="center"
            wrap="nowrap"
          >
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                variant="outlined"
                label="Country"
                select={countries.length > 0}
                value={countries.length > 0 ? selectedCountry.countryName : ""}
                onChange={handleCountryChange}
                size="small"
              >
                {countries.length > 0
                  ? countries.map((country) => (
                      <MenuItem key={country.countryID} value={country.countryName}>
                        {country.countryName}
                      </MenuItem>
                    ))
                  : null}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <TextField
                variant="outlined"
                label="Partner Type"
                select={getCustomerGroupRefData?.customerLevels?.length > 0}
                value={partnerType}
                onChange={handlePartnerTypeChange}
                size="small"
              >
                {getCustomerGroupRefData?.customerLevels?.map((item) => (
                  <MenuItem key={item.customerLevelID} value={item.customerLevelID}>
                    {item.customerLevel}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                variant="outlined"
                label="Customer Type"
                select={getCustomerGroupRefData?.customerLevels?.length > 0}
                value={customerType}
                onChange={handleCustomerTypeChange}
                size="small"
              >
                {getCustomerGroupRefData?.customerTypes?.slice(0, 4).map((item) => (
                  <MenuItem
                    key={item.customerTypeCode}
                    value={item.customerTypeCode}
                  >
                    {item.customerTypeCode} | {item.customerTypeName}
                  </MenuItem>
                ))}
                {getCustomerGroupRefData?.customerTypes?.length > 4 && (
                  <div
                    style={{
                      borderBottom: "dashed 2px",
                      padding: "5px",
                      marginBottom: "6px",
                    }}
                  ></div>
                )}
                {getCustomerGroupRefData?.customerTypes?.slice(4).map((item) => (
                  <MenuItem
                    key={item.customerTypeCode}
                    value={item.customerTypeCode}
                  >
                    {item.customerTypeCode} | {item.customerTypeName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                variant="outlined"
                label="Search"
                value={searchText}
                onChange={handleSearchText}
                size="small"
              ></TextField>
            </Grid>

            <Grid item xs={12} sm={6} md="auto">
              <Box justifyContent="flex-end" display="flex">
                <CustomButton
                  onClick={handleDisplay}
                  size="medium"
                >
                    Search
                  </CustomButton>
              </Box>
            </Grid>
          </Grid>
        </Box>
      {showCustomerTrustLevel && (
        <Box
          mt={2}
          sx={{
            width: "100%",
            minHeight: "200px",
          }}
        >
          <DataGrid
            sx={{
              "& .MuiDataGrid-columnHeaders":{
                backgroundColor:"grey.lighter"
              }
            }}
            style={{ maxHeight: "calc(100vh - 130px)" }}
            apiRef={apiRef}
            rows={rows}
            columns={columns}
            getRowId={(row) => row?.id}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20, 50, 100]}
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
            }}
            rowSelectionModel={rowSelectionModel}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      )}
      {rowSelectionModel.length > 0 ? (
        <Box mt={3} justifyContent="flex-end" display="flex">
                <CustomButton
                     onClick={handleSave}
                     size="large"
                     disabled={!isRestrictedAccess}       
                          >
                        Save your changes
                </CustomButton>
        </Box>
      ) : (
        <></>
      )}
      {alert.alertDisplay && (
          <MessageSnackbar
          message={alert.alertMessage}
          severity={alert.alertSeverity}
          open={alert.alertDisplay}
          onClose={handleCloseSnackbar}
        />
      )}
    </Box>
  );
}

export default CustomerTrustLevel